import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 25 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      "clip-path": "url(#group_size_3-acq3ij__a)"
    }, [
      _createElementVNode("path", { d: "M4.667 8.25a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5ZM4.667 9.75a3.75 3.75 0 0 0-3.75 3.75v2.25h1.5l.75 6h3M19.667 8.25a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5ZM19.667 9.75a3.75 3.75 0 0 1 3.75 3.75v2.25h-1.5l-.75 6h-3M12.167 6.75a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM17.417 13.5a5.25 5.25 0 0 0-10.5 0v2.25h2.25l.75 7.5h4.5l.75-7.5h2.25V13.5Z" })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "group_size_3-acq3ij__a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M.167 0h24v24h-24z"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }